<!-- eslint-disable max-len -->
<template>
  <svg fill="none" height="24" stroke-width="1.5" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path d="M19.7772 4.22198L15.5352 8.46398" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" />
      <path d="M19.7772 19.778L15.5352 15.536" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" />
      <path d="M4.22266 19.778L8.46466 15.536" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" />
      <path d="M4.22266 4.22198L8.46466 8.46398" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" />
      <path
        d="M19.7777 19.7781C24.0734 15.4824 24.0734 8.51763 19.7777 4.2219C15.4819 -0.0738257 8.51719 -0.0738257 4.22146 4.2219C-0.0742669 8.51763 -0.0742669 15.4824 4.22146 19.7781C8.51719 24.0738 15.4819 24.0738 19.7777 19.7781Z"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
      />
      <path
        d="M15.5342 15.5355C17.4868 13.5829 17.4868 10.4171 15.5342 8.4645C13.5816 6.5119 10.4158 6.5119 8.46323 8.4645C6.51063 10.4171 6.51063 13.5829 8.46323 15.5355C10.4158 17.4881 13.5816 17.4881 15.5342 15.5355Z"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
      />
    </g>
  </svg>
</template>
